import { useEffect, useState } from "react";
//import { useStyles } from "../../style";
import { Box, CircularProgress, Dialog, FormControl, Grid, InputLabel, MenuItem, Select, Typography } 
from "@mui/material";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import dayjs from "dayjs";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import { dashboardText, icon34, mainGrid, paddingbox, paddingboxeven, rcolor, smallText } from "../../style2";


export default function SeizureDiary(props) {
    
    // If startDate and endDate are supplied via props, the component operates in
    // date-range mode: it calls a different API endpoint, hides the month/year
    // selectors, and displays the date range in the heading instead.
    // When these props are absent, the default year/month selector behaviour applies.
    const { startDate, endDate } = props;
    const useDateRange = startDate && endDate;
    const [selectedYear, setSelectYear] = useState(dayjs().year());
    const [selectedMonth, setSelectMonth] = useState(0);
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedEntry, setSelectedEntry] = useState(null);
    //const [showSeizureTypeDetails, setShowSeizureTypeDetails] = useState(false);
    const ls = new AccessLocalStorage();

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }

        const url = useDateRange
            ? `${getApiUrl()}/seizurediary/getbydate/${ls.getCurrentPatientId()}?sd=${startDate}&ed=${endDate}`
            : `${getApiUrl()}/seizurediary/${ls.getCurrentPatientId()}/${selectedYear}/${selectedMonth}`;

        fetch(url,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                let result = [];
                data.forEach((e) => {
                    if (!e.isDeleted) {
                        result.push(e);
                    }

                });
                data.forEach((e) => {
                    if (e.isDeleted)
                        result.push(e);
                });
                setEntries(result);

            })
            .catch((err) => {
                setError(err.message || "An error occurred.");
                setEntries([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedYear, selectedMonth, props.newJournalCreatedTime, startDate, endDate]);

    const renderYearOptions = () => {
        let items = [];
        let d = new Date(Date.now());
        for (let i = d.getFullYear(); i > d.getFullYear() - 25; i--) {
            items.push(<MenuItem value={i}>{i}</MenuItem>);
        }
        return items;
    }

    const renderShowEntry = () => {
        if (selectedEntry !== null) {
            return <Dialog open={true} onClose={() => { setSelectedEntry(null); }} fullWidth maxWidth="md">
                <Grid container sx={{
                    backgroundColor: "#fff",
                    padding: "10px 20px",
                    position: "sticky",
                    top: 0,
                    zIndex: 10
                }}>
                    <Grid item xs={11} >
                        <Typography title="Entry Date" sx={{ fontWeight: "bold", color: rcolor, fontSize: "17px" }}>
                            Seizure Diary - {dayjs(selectedEntry.entryDate).format("DD/MM/YY")}
                        </Typography>
                    </Grid>
                    <Grid item xs={1} sx={{ textAlign: "right", cursor: "pointer" }}>
                        <CloseIcon onClick={() => { setSelectedEntry(null); }} />
                    </Grid>
                </Grid>
                <Grid sx={{
                    padding: "10px 20px",
                    maxHeight: "70vh",   // adjust height as needed
                    overflowY: "auto"
                }}>
                    <Typography component="div" sx={{ fontWeight: "bold", marginBottom: "10px" }}>Seizure Type</Typography>
                    {selectedEntry.seizureTypes && selectedEntry.seizureTypes.length > 0 &&
                        selectedEntry.seizureTypes.map((st, index) => {
                            return <SeizureTypeDetails key={index}
                                seizureType={st}
                                renderers={{
                                    renderSeizureBodyType,
                                    renderSeizureArmInvolvedType,
                                    renderSeizureAwarenessType,
                                    renderSeizureEyeInvolvedType,
                                    renderSeizureLegInvolvedType,
                                    renderSeizureFaceInvolvedType
                                }}
                            />
                        })}
                    <Grid container spacing={2} style={{ marginTop: "10px", marginBottom: "10px" }}>
                        {selectedEntry.numberofSeizures > 0 ? <Grid item xs={12} md={6} >
                            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Number of Seizures</Typography>
                            <Typography component="div" style={{ marginBottom: "5px" }}>{selectedEntry.numberofSeizures} </Typography>
                        </Grid> : null}

                        <Grid item xs={12} md={6} >
                            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Length Of Seizure</Typography>
                            <Typography component="div" style={{ marginBottom: "5px" }}>{selectedEntry.lengthOfSeizure} </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Time Occured</Typography>
                            <Typography fontWeight="bold" style={{ marginBottom: "5px" }}>{selectedEntry.timeOccuredDisplay} </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Recovery Medication</Typography>
                            <Typography fontWeight="bold" style={{ marginBottom: "5px" }}>{selectedEntry.recoveryMedication ? "Yes" : "No"}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Recovery Back to Normal</Typography>
                            <Typography fontWeight="bold" style={{ marginBottom: "5px" }}>
                                {renderRecoveryTimeBackToNormalType(selectedEntry.recoveryTimeBackToNormalType)}
                            </Typography>
                        </Grid>
                    </Grid>
                    {selectedEntry.note !== "" && selectedEntry.note !== null ? <>
                        <Typography component="div" style={{ fontWeight: "bold", marginBottom: "10px" }}>Notes</Typography>
                        <Box style={{ padding: "10px 5px", margin: "10px 0px ", borderTop: "1px solid gainsboro", borderBottom: "1px solid gainsboro" }}>
                            <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px", whiteSpace: "pre-line" }}>{selectedEntry.note}</Typography>
                        </Box></> : null}
                    {selectedEntry.triggers && selectedEntry.triggers.list && selectedEntry.triggers.list.length > 0 ? <>
                        <Typography component="div" style={{ fontWeight: "bold", marginBottom: "10px" }}>Possible Tiggers</Typography>
                        <Box style={{ padding: "10px 5px", margin: "10px 0px ", borderTop: "1px solid gainsboro", borderBottom: "1px solid gainsboro" }}>
                            {selectedEntry.triggers.list.map((trigger, index) => {
                                if (trigger.name.toLowerCase() === "other") { return null; }
                                return <Box key={index}>
                                    <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px", whiteSpace: "pre-line" }}>{trigger.displayName}</Typography>
                                </Box>;
                            })}
                            {selectedEntry.triggers.other && selectedEntry.triggers.other !== "" ? <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px", whiteSpace: "pre-line" }}>{selectedEntry.triggers.other}</Typography> : null}
                        </Box>
                    </> : null}
                    <Grid container fullWidth >
                        <Grid item xs={6}>
                            <Typography style={{ color: "rgb(84, 84, 84)", fontSize: "15px" }}>
                                <span style={{ marginRight: "15px" }}>Created on</span> {moment.utc(selectedEntry.createdAt).local().format("DD/MM/YYYY h:mm A")}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography style={{ color: "rgb(84, 84, 84)", fontSize: "15px", textAlign: "right" }}>
                                Entered by - {selectedEntry.createdByName}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Dialog>;
        }
        return null;
    }

    return (<Box sx={(props.fullWidth ? null : paddingbox)} id={props.id}>
        <Grid container>
            <Grid item xs={12} container>
                <Grid item xs={useDateRange ? 12 : 8}>
                    <Box display="flex" alignItems="center" sx={dashboardText}>
                        <Box component="img" src={props.icon ? props.icon : `assets/epilepsy.png`} sx={icon34}></Box> <Box mr={1} />
                        <Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>
                            {useDateRange
                                ? `Seizure Diary - ${dayjs(startDate).format("DD/MM/YY")} to ${dayjs(endDate).format("DD/MM/YY")}`
                                : `Seizure Diary - ${renderMonthName(selectedMonth)}${selectedYear}`}
                        </Typography>
                        {loading ? <span style={{ marginLeft: 10 }}><CircularProgress size={20} /></span> : null}
                    </Box>
                </Grid>
                {!useDateRange && (
                    <>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 120, paddingRight:1 }} size="small">
                                <InputLabel id="seizurediary-month-select-label">Month</InputLabel>
                                <Select disabled={loading} labelId="seizurediary-month-select-label"
                                    id="seizurediary-month-select" value={selectedMonth} label="Month" onChange={(event) => { setSelectMonth(event.target.value); }}>
                                    <MenuItem value={0}>Month</MenuItem>
                                    <MenuItem value={1}>Jan</MenuItem>
                                    <MenuItem value={2}>Feb</MenuItem>
                                    <MenuItem value={3}>Mar</MenuItem>
                                    <MenuItem value={4}>Apr</MenuItem>
                                    <MenuItem value={5}>May</MenuItem>
                                    <MenuItem value={6}>Jun</MenuItem>
                                    <MenuItem value={7}>Jul</MenuItem>
                                    <MenuItem value={8}>Aug</MenuItem>
                                    <MenuItem value={9}>Sep</MenuItem>
                                    <MenuItem value={10}>Oct</MenuItem>
                                    <MenuItem value={11}>Nov</MenuItem>
                                    <MenuItem value={12}>Dec</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{marginBottom: 1, minWidth: 120, paddingRight:1 }} size="small">
                                <InputLabel id="seizurediary-year-select-label">Year</InputLabel>
                                <Select disabled={loading} labelId="seizurediary-year-select-label"
                                    id="seizurediary-year-select" value={selectedYear} label="Year" onChange={(event) => { setSelectYear(event.target.value); }}>
                                    {renderYearOptions()}
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                )}
            </Grid>
            <Box m={1} />
            <Grid item xs={12}>
                <Box sx={{...mainGrid, padding: "20px", overflowX: "auto", overflowY: "hidden" }}>
                    {entries.length > 0 ? <table cellPadding={0} cellSpacing={0} >
                        <tbody>
                            <tr>
                                {entries.map((entry) => (
                                    <td key={entry.id} align="center" valign="middle" style={{ padding: "8px", cursor: "pointer" }} onClick={() => { setSelectedEntry(entry); }}>
                                        <div style={{ minHeight: "85px", minWidth: "200px", padding: "5px 10px", background: "#ffffff", borderRadius: "10px", marginBottom: "10px" }}>
                                            <table style={{ width: "100%", paddingBottom: "10px" }}>
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={2}>
                                                            <Typography title="" sx={{...smallText, paddingTop: "4px" }}>
                                                                Seizure Type :
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={2}>
                                                            {entry.seizureTypes && entry.seizureTypes.map((st, index) => {
                                                                return <Typography key={index} sx={{...smallText, paddingRight: "5px" }} title="" component="span">
                                                                    {st.seizureTypeName}
                                                                </Typography>
                                                            })}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography title="" sx={{...smallText, paddingTop: "4px" }}>
                                                                Length of Seizure :
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography title="" sx={{...smallText, paddingTop: "4px" }}>
                                                                {entry.lengthOfSeizure}
                                                            </Typography>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <Typography title="" sx={{...smallText, paddingTop: "4px" }}>
                                                                Time of Seizure :
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography title="" sx={{...smallText, paddingTop: "4px" }}>
                                                                {entry.timeOccuredDisplay !== "" ? entry.timeOccuredDisplay : "-"}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    {/* <tr>
                                                        <td>
                                                            <Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px" }}>
                                                                Recovery Medication
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography title="" style={{ fontSize: "0.7rem", paddingTop: "4px" }}>
                                                                {entry.recoveryMedication ? "Yes" : "No"}
                                                            </Typography>
                                                        </td>
                                                    </tr> */}

                                                </tbody>
                                            </table>

                                        </div>
                                        <Typography title="Entry Date" style={{ fontSize: "0.965rem" }} >
                                            {dayjs(entry.entryDate).format("DD/MM/YY")}
                                        </Typography>
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table> : null}
                    {entries.length == 0 && !loading ? <Typography>No Seizure Diary Entries</Typography> : null}
                    {renderShowEntry()}
                </Box>
            </Grid>
        </Grid>
    </Box>);
}
export const renderMonthName = (sm) => {
    switch (sm) {
        case 0:
            return "";
        case 1:
            return "Jan ";
        case 2:
            return "Feb ";
        case 3:
            return "Mar ";
        case 4:
            return "Apr ";
        case 5:
            return "May ";
        case 6:
            return "Jun ";
        case 7:
            return "Jul";
        case 8:
            return "Aug ";
        case 9:
            return "Sep ";
        case 10:
            return "Oct ";
        case 11:
            return "Nov ";
        case 12:
            return "Dec ";

    }
}

export const renderRecoveryTimeBackToNormalType = (value) => {
    switch (value) {
        case 1:
            return "Less Than 1 Minute";
        case 2:
            return "Less Than 10 Minutes";
        case 3:
            return "More Than 10 Minutes";
        case 4:
            return "Slept";
        case 5:
            return "Other";
        default:
            return "";
    }
}

export const renderSeizureEyeInvolvedType = (value) => {
    switch (value) {
        case 1:
            return "Rolled Back";
        case 2:
            return "To Side";
        case 3:
            return "Closed";
        default:
            return "";
    }
}

export const renderSeizureFaceInvolvedType = (value) => {
    switch (value) {
        case 1:
            return "Blinking";
        case 2:
            return "Twitching";
        case 3:
            return "Mouthing";
        case 4:
            return "Drooling";
        case 5:
            return "Other";
        default:
            return "";
    }
}

export const renderSeizureArmInvolvedType = (value) => {
    switch (value) {
        case 1:
            return "Stiff";
        case 2:
            return "Jerking";
        case 3:
            return "Tremors";
        case 4:
            return "Other";
        default:
            return "";
    }
}

export const renderSeizureLegInvolvedType = (value) => {
    switch (value) {
        case 1:
            return "Stiff";
        case 2:
            return "Jerking";
        case 3:
            return "Tremors";
        case 4:
            return "Other";
        default:
            return "";
    }
}

export const renderSeizureAwarenessType = (value) => {
    switch (value) {
        case 1:
            return "Aware";
        case 2:
            return "Impaired Awareness";
        case 3:
            return "Unaware";
        default:
            return "";
    }
}

export const renderSeizureBodyType = (value) => {
    switch (value) {
        case 1:
            return "Stiff";
        case 2:
            return "Floppy";
        case 3:
            return "Other";
        default:
            return "";
    }
}
export function SeizureTypeDetails({ seizureType, renderers = {} }) {
    const [showDetails, setShowDetails] = useState(false);

    // Destructure seizureType object
    const {
        seizureTypeName,
        comments,
        bodyType,
        armInvolvedType,
        awarenessType,
        eyeInvolvedType,
        legInvolvedType,
        faceInvolvedType,
    } = seizureType;

    // Destructure renderers with defaults
    const {
        renderSeizureBodyType = v => v,
        renderSeizureArmInvolvedType = v => v,
        renderSeizureAwarenessType = v => v,
        renderSeizureEyeInvolvedType = v => v,
        renderSeizureLegInvolvedType = v => v,
        renderSeizureFaceInvolvedType = v => v,
    } = renderers;

    return (
        <Box>
            <Box
                style={{
                    marginBottom: "10px",
                    color: "rgb(79, 191, 168)",
                    cursor: "pointer",
                    fontWeight: "bold",
                    textDecoration: "underline"
                }}
                onClick={() => setShowDetails(!showDetails)}
            >
                {seizureTypeName}
            </Box>
            {showDetails && (
                <Box p={2} style={{ border: "1px solid #000", borderRadius: "10px", marginBottom: "20px" }}>
                    <table style={{ width: "90%" }}>
                        <tbody>
                            <tr>
                                <td style={{ fontWeight: "bold" }}>Body</td>
                                <td style={{ fontWeight: "bold" }}>Arm</td>
                                <td style={{ fontWeight: "bold" }}>Awareness</td>
                            </tr>
                            <tr>
                                <td>
                                    <Typography fontWeight="bold">
                                        {seizureType.bodyTypeDisplay}
                                    </Typography>
                                    <Box p={1}></Box>
                                </td>
                                <td>
                                    <Typography fontWeight="bold">
                                        {seizureType.armInvolvedTypeDisplay}
                                    </Typography>
                                    <Box p={1}></Box>
                                </td>
                                <td>
                                    <Typography fontWeight="bold">
                                        {seizureType.awarenessTypeDisplay}
                                    </Typography>
                                    <Box p={1}></Box>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold" }}>Eye</td>
                                <td style={{ fontWeight: "bold" }}>Leg</td>
                                <td style={{ fontWeight: "bold" }}>Face</td>
                            </tr>
                            <tr>
                                <td>
                                    <Typography fontWeight="bold">
                                        {seizureType.eyeInvolvedTypeDisplay}
                                    </Typography>
                                    <Box p={1}></Box>
                                </td>
                                <td>
                                    <Typography fontWeight="bold">
                                        {seizureType.legInvolvedTypeDisplay}
                                    </Typography>
                                    <Box p={1}></Box>
                                </td>
                                <td>
                                    <Typography fontWeight="bold">
                                        {seizureType.faceInvolvedTypeDisplay}
                                    </Typography>
                                    <Box p={1}></Box>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} style={{ fontWeight: "bold" }}>Comments</td>
                            </tr>
                            <tr>
                                <td colSpan={3}><Typography style={{ whiteSpace: "pre-line" }}>
                                    {comments}
                                </Typography></td>
                            </tr>
                        </tbody>
                    </table>
                </Box>
            )}
        </Box>
    );
}